// extracted by mini-css-extract-plugin
export default {"item":"Logo2_item__1w8zD","blogu":"Logo2_blogu__1fA4G"};